import { render, staticRenderFns } from "./ManualStudy.vue?vue&type=template&id=b46febba&"
import script from "./ManualStudy.vue?vue&type=script&lang=ts&"
export * from "./ManualStudy.vue?vue&type=script&lang=ts&"
import style0 from "./ManualStudy.vue?vue&type=style&index=0&id=b46febba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports